import { ca } from '@cian/analytics';

/**
 * Клик по ссылке нужна помощь
 */
export function trackRememberedAccountsNeedHelp() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'latest_account_cant_confirm'
  });
}